import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconImac"><Path d="M4.75 3C3.23122 3 2 4.23122 2 5.75V12.5H22V5.75C22 4.23122 20.7688 3 19.25 3H4.75Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 15.25V14H22V15.25C22 16.7688 20.7688 18 19.25 18H15V21.25C15 21.6642 14.6642 22 14.25 22H9.75C9.33579 22 9 21.6642 9 21.25V18H4.75C3.23122 18 2 16.7688 2 15.25ZM10.5 18V20.5H13.5V18H10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImac;
